/**
 * @generated SignedSource<<c2786d32df34254f7857451cef511714>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueStatsTTRGraph_IssueStats$data = {
  readonly timeToResolveBucketed: {
    readonly bucketTimeSeconds: number;
    readonly counts: ReadonlyArray<number>;
    readonly total: number;
  };
  readonly " $fragmentType": "IssueStatsTTRGraph_IssueStats";
};
export type IssueStatsTTRGraph_IssueStats$key = {
  readonly " $data"?: IssueStatsTTRGraph_IssueStats$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueStatsTTRGraph_IssueStats">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fromDate"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueStatsTTRGraph_IssueStats",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "fromDate",
          "variableName": "fromDate"
        }
      ],
      "concreteType": "IssueTimeToResolveBucketed",
      "kind": "LinkedField",
      "name": "timeToResolveBucketed",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bucketTimeSeconds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "counts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "total",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IssueStats",
  "abstractKey": null
};

(node as any).hash = "e3553e80ae853d4331e5c1dde3c0ad6c";

export default node;
